import React from 'react';
import { Calendar, MapPin } from 'lucide-react';

export const FeaturedEvent = () => {
  const scrollToNews = () => {
    const el = document.getElementById('news');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="featured-event"
      className="py-16 bg-gradient-to-b from-cyan-50/50 to-white"
      data-testid="featured-event-section"
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 bg-cyan-500 text-white px-4 py-1.5 rounded-full text-sm font-semibold mb-4 shadow-md">
            <Calendar className="w-4 h-4" />
            Evento in primo piano
          </div>

          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-3">
            Domenica 17 maggio
          </h2>
          <p className="text-base sm:text-lg text-gray-600 mb-8 flex items-center justify-center gap-2">
            <MapPin className="w-5 h-5 text-cyan-600" />
            Ore 9:30 — Piazza Rigo, Spresiano
          </p>

          <button
            onClick={scrollToNews}
            className="group block w-full rounded-2xl overflow-hidden shadow-2xl hover:shadow-cyan-200/60 transition-all duration-300 hover:-translate-y-1 ring-4 ring-cyan-100 hover:ring-cyan-200"
            data-testid="featured-event-card"
            aria-label="Vai ai prossimi appuntamenti"
          >
            <img
              src="/images/events/featured-17-maggio.webp"
              alt="Volantino evento Domenica 17 maggio - Giovanni Manildo, Elena Stocco, Mirella Balliana saranno con noi in piazza Rigo"
              loading="eager"
              fetchpriority="high"
              decoding="async"
              className="w-full h-auto group-hover:scale-[1.02] transition-transform duration-500"
            />
          </button>
        </div>
      </div>
    </section>
  );
};
